// External Dependencies
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useSelector } from 'react-redux';

// Internal Dependencies
import { selectStripeClientSecret } from '../../state/selectors/selectors';

// Publishable key is not sensitive and can be exposed to the client
export const STRIPE_PUBLISHABLE_KEY =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

const StripeProvider = ({ children }) => {
  const clientSecret = useSelector(selectStripeClientSecret);

  const options = {
    clientSecret,
  };

  return clientSecret ? (
    <Elements options={options} stripe={stripePromise}>
      {children}
    </Elements>
  ) : (
    children
  );
};

export default StripeProvider;
